import React from "react";
import "./SavedLocationModals.css";

function SavedLocationModals({
 showCreateLocationModal,
 setShowCreateLocationModal,
 showEditLocationsModal,
 setShowEditLocationsModal,
 newSavedLocationForm,
 setNewSavedLocationForm,
 editingSavedLocations,
 setEditingSavedLocations,
 savedLocations,
 handleCreateSavedLocation,
 handleEditSavedLocationField,
 handleSaveEditedLocations,
 handleDeleteSavedLocation,
}) {
 return (
  <>
   {showCreateLocationModal && (
    <div className="game-schedule-modal-overlay savedLocationModalsPage-overlay">
     <div className="savedLocationModalsPage-modal savedLocationModalsPage-smallModal">
      <h3>Create New Location</h3>

      <form onSubmit={handleCreateSavedLocation}>
       <label>
        Location Name
        <input
         type="text"
         value={newSavedLocationForm.name}
         onChange={(e) =>
          setNewSavedLocationForm((prev) => ({
           ...prev,
           name: e.target.value,
          }))
         }
         required
        />
       </label>

       <label>
        Location URL
        <input
         type="text"
         value={newSavedLocationForm.location_url}
         onChange={(e) =>
          setNewSavedLocationForm((prev) => ({
           ...prev,
           location_url: e.target.value,
          }))
         }
        />
       </label>

       <div className="game-modal-action-row">
        <button type="submit">Create</button>

        <button
         type="button"
         onClick={() => {
          setShowCreateLocationModal(false);
          setNewSavedLocationForm({
           name: "",
           location_url: "",
          });
         }}
        >
         Cancel
        </button>
       </div>
      </form>
     </div>
    </div>
   )}

   {showEditLocationsModal && (
    <div className="game-schedule-modal-overlay savedLocationModalsPage-overlay">
     <div className="savedLocationModalsPage-modal savedLocationModalsPage-editModal">
      <h3>Edit Current Locations</h3>

      <form onSubmit={handleSaveEditedLocations}>
       <div className="saved-location-edit-list">
        {editingSavedLocations.length === 0 ? (
         <p>No saved locations yet.</p>
        ) : (
         editingSavedLocations.map((loc) => (
          <div key={loc.id} className="saved-location-edit-item">
           <input
            type="text"
            value={loc.name || ""}
            placeholder="Location name"
            onChange={(e) =>
             handleEditSavedLocationField(
              loc.id,
              "name",
              e.target.value
             )
            }
           />

           <div className="saved-location-url-row">
            <input
             type="text"
             value={loc.location_url || ""}
             placeholder="Location URL"
             onChange={(e) =>
              handleEditSavedLocationField(
               loc.id,
               "location_url",
               e.target.value
              )
             }
            />

            <button
             type="button"
             className="saved-location-delete-btn"
             onClick={() => handleDeleteSavedLocation(loc.id)}
             title="Delete saved location"
            >
             🗑️
            </button>
           </div>
          </div>
         ))
        )}
       </div>

       <div className="game-modal-action-row">
        <button type="submit">Save</button>

        <button
         type="button"
         onClick={() => {
          setShowEditLocationsModal(false);
          setEditingSavedLocations(savedLocations);
         }}
        >
         Cancel
        </button>
       </div>
      </form>
     </div>
    </div>
   )}
  </>
 );
}

export default SavedLocationModals;